import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/logo.jpg"

const Header = () => {
    return (
        <header>
            <div className="links">
                <NavLink to="/" activeClassName="active" exact>
                    <img src={logo} alt="logo" className="logo-img" />
                </NavLink>
                <NavLink to="/" className="link">Home</NavLink>
                <NavLink to="/about" className="link">About Me</NavLink>
                <NavLink to="/projects" className="link">Projects</NavLink>
                <NavLink to="/contactme" className="link">Contact Me</NavLink>
            </div>
        </header>
    )
}

export default Header;